import React, { Component } from "react";
import { withRouter } from "../../withRouter";
import { MenuWithBreadScrum } from "../menu/MenuWithBreadScrum";
import { Menu, Button } from "@mui/material";
import TextField from "@material-ui/core/TextField";
import { InputAdornment } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import FetchServerData from "../../provider/FetchServerData";
import store from "../../redux/store";
import "./AssetTrackingHistoryList.css";
import Pagination from "./Pagination";
import Utils from "../../provider/Utils";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import DatePicker from "react-datepicker";
import MenuAction from "../../redux/menu/MenuAction";
import _ from "lodash";
import * as XLSX from "xlsx";
import moment from "moment";

const formatTrackingDateTime = (dateTime) => {
  if (dateTime === null) {
    return "";
  }

  return moment(new Date(dateTime)).format("MMM DD, YYYY HH:mm A");
};

const getUserInitials = (name) => {
  if (!name) {
    return "";
  }

  return name
    .trim()
    .split(/\s+/)
    .map((part) => part.charAt(0).toUpperCase())
    .join("");
};

class AssetTrackingHistoryList extends Component {
  header = store.getState().header.header;
  breadCrumb = [{ pageid: "", uiname: "Asset Tracking History List" }];
  constructor(props) {
    super(props);
    let assetId = "";
    let userMenuArray = Utils.getTopMenus();
    if (props.state) {
      assetId = props.state.assetId;

      for (let i = 0; i < userMenuArray.length; i++) {
        for (
          let j = 0;
          props.state.pageid && j < props.state.pageid?.length;
          j++
        ) {
          if (userMenuArray[i].pageid === props.state.pageid) {
            store.dispatch(MenuAction.setActiveMenu(userMenuArray[i].id));
          }
        }
      }
    }
    this.state = {
      assetId: assetId,
      render: false,
      searchText: "",
      startDate: "",
      endDate: "",
      selectedAssetCodeId: "",
      pageNo: 0,
      showPerPage: 0,
      pageSize: 20,
      trackingHistoryList: [],
      assetCodeList: [],
      selectedTrackingId: false,
      open: false,
      isFirstTimeLoading: true,
    };
    this.getTrakingHistoryList(this.state.pageNo, this.state.pageSize);
    this.getAssetCodeList();
    this.debouncedSearch = _.debounce(this.getTrakingHistoryList, 800);
  }
  /*Real time messaging thread functionality */
  componentDidMount() {
    this.unsubscribe = store.subscribe(() => {
      let receiveTrackingHistoryList = this.state.trackingHistoryList;
      let newTrackingData = store.getState().trackingHistory.history;
      for (let i = 0; i < newTrackingData.length; i++) {
        newTrackingData[i].selectedTrack = true;
        receiveTrackingHistoryList.unshift(newTrackingData[i]);
      }

      this.setState({
        selectedTrackingId: true,
        trackingHistoryList: receiveTrackingHistoryList,
      });

    });
  }

  componentWillUnmount() {
    this.unsubscribe();
  }
  getAssetCodeList() {
    const postObject = {
      header: this.header,
    };
    FetchServerData.callPostService("/assetcodems/getList", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let assetCodeList = output?.data?.assetCodes || [];
          for (let i = 0; i < assetCodeList.length; i++) {
            assetCodeList[i] = assetCodeList[i].code;
          }
          console.log(assetCodeList);
          this.setState({
            assetCodeList: assetCodeList,
          });
        }
      }
    );
  }
  onFilterClick() {
    if (
      this.state.startDate !== null &&
      this.state.endDate !== null &&
      this.state.startDate > this.state.endDate
    ) {
      this.setState({ error: true });
      return false;
    }
    this.setState({
      isFirstTimeLoading: false,
      open: false,
    });
    this.getTrakingHistoryList(this.state.pageNo, this.state.pageSize);
  }

  resetFilter() {
    this.setState({ searchText: "", selectedAssetCodeId: "" }, () => {
      this.getTrakingHistoryList(this.state.pageNo, this.state.pageSize, true);
    });
  }

  downloadExcel() {
    const postObject = {
      header: this.header,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      assetCode: this.state.selectedAssetCodeId,
      page: {
        searchText: this.state.searchText,
        pageNo: this.state.pageNo,
        pageSize: this.state.pageSize,
      },
    };
    FetchServerData.callPostService(
      "/trackingHistory/getLatestHistory",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let trackingHistoryData = output.data.history;
        let excelData = trackingHistoryData.map((rowData, index) => ({
          "#": index + 1,
          "Plan Name": rowData.planName,
          "Asset Name": rowData.assetname,
          "Asset UID": rowData.assetuid,
          Action: rowData.action,
          "First Track Date": formatTrackingDateTime(rowData.tdate),
          "Latest Track Date": formatTrackingDateTime(rowData.tenddate),
          "Creator": rowData.createdbyName,
          Location: rowData.location ? rowData.location : "",
          Count: rowData.count,
        }));
        const worksheet = XLSX.utils.json_to_sheet(excelData);
        worksheet["!cols"] = Object.keys(excelData[0] || {}).map((column) => {
          const largestCell = excelData.reduce(
            (largest, row) =>
              Math.max(largest, String(row[column] ?? "").length),
            column.length
          );
          return { wch: Math.min(Math.max(largestCell + 2, 10), 40) };
        });
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
          workbook,
          worksheet,
          "Asset Tracking History"
        );
        XLSX.writeFile(
          workbook,
          `AssetTrackingHistory_${Date.now()}.xlsx`
        );
      }
    });
  }

  onSearchChange(e) {
    this.setState({ searchText: e.target.value });
    this.debouncedSearch(0, this.state.pageSize);
  }

  onSearchClick() {
    this.setState({
      isFirstTimeLoading: false,
    });
    this.getTrakingHistoryList(this.state.pageNo, this.state.pageSize);
  }

  handleCycleFromDateChange(date) {
    this.setState({ startDate: date });
  }

  handleCycleToDateChange(date) {
    this.setState({ endDate: date });
  }

  handleAccountDropdownOpen = (e) => {
    this.setState({ open: true, anchorEl: e.currentTarget });
  };

  handleAccountDropdownClose = () => {
    this.setState({ open: false, anchorEl: null });
  };

  getTrakingHistoryList(pageNo, pageSize, reset) {
    const postObject = {
      header: this.header,
      startDate: reset ? "" : this.state.startDate,
      endDate: reset ? "" : this.state.endDate,
      assetCode: reset ? "" : this.state.selectedAssetCodeId,
      page: {
        searchText: this.state.searchText,
        pageNo: pageNo,
        pageSize: pageSize,
      },
    };
    FetchServerData.callPostService(
      "/trackingHistory/getLatestHistory",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let trackingHistoryData = output.data;
        for (let i = 0; i < trackingHistoryData.history.length; i++) {
          trackingHistoryData.history[i].selectedTrack = false;
        }
        this.setState({
          render: true,
          open: false,
          error: false,
          startDate: reset ? "" : this.state.startDate,
          endDate: reset ? "" : this.state.endDate,
          isFirstTimeLoading:
            reset || this.state.isFirstTimeLoading ? true : false,
          selectedTrackingId: false,
          trackingHistoryList: trackingHistoryData.history,
          searchText: trackingHistoryData.page.searchText,
          pageNo: trackingHistoryData.page.pageNo,
          showPerPage: trackingHistoryData.page.pageSize,
          totalPages: trackingHistoryData.page.totalPages,
          totalRecords: trackingHistoryData.page.total,
        });
      } else {
      }
    });
  }
  onPaginationChange(returnProp) {
    let counter = returnProp.counter;
    let pageNo = this.state.pageNo + counter;
    let pageSize = returnProp.showPerPage;
    let buttonIndex = returnProp.buttonIndex;
    let currentPageIndex =
      typeof counter !== "undefined" ? pageNo : buttonIndex;
    let resetPageNo = returnProp.resetPageNo;
    if (resetPageNo === true) {
      currentPageIndex = 0;
    }
    this.setState({
      pageNo: currentPageIndex,
      pageSize: pageSize
    });
    this.debouncedSearch = _.debounce(this.getTrakingHistoryList, 800);
    this.getTrakingHistoryList(currentPageIndex, pageSize);
  }

  toAssetTrakingDetails(assetId) {
    this.props.navigate("/asset", {
      state: {
        // categoryId: this.state.categoryId,
        action: "view",
        assetId: assetId,
        replace: true,
        pageId: "assetTrackHistoryList",
      },
    });
  }
  render() {
    const activeFilterEntries = [];

    if (this.state.startDate) {
      activeFilterEntries.push(
        <span key="from-date">
          <b>From : </b>
          {Utils.getUtcToLocal(this.state.startDate) + ", "}
        </span>
      );
    }

    if (this.state.endDate) {
      activeFilterEntries.push(
        <span key="to-date">
          <b>To : </b>
          {Utils.getUtcToLocal(this.state.endDate) + ", "}
        </span>
      );
    }

    if (this.state.selectedAssetCodeId) {
      activeFilterEntries.push(
        <span key="asset-code">
          <b>Asset Code : </b>
          {this.state.selectedAssetCodeId}
        </span>
      );
    }

    const hasActiveFilters = activeFilterEntries.length > 0;

    console.log(this.state.searchText);
    if (this.state.render === false) {
      return <div />;
    } else {
      return (
        <>
          <MenuWithBreadScrum
            breadCrumb={this.breadCrumb}
            navigate={this.props.navigate}
            domainObject="Asset"
            name="Asset Tracking History"
          />
          <div className="row">
            <div className="col">
              <div className="row align-items-end text-end">
                <div className="col">
                  {hasActiveFilters && (
                    <span>
                      (
                      {activeFilterEntries.map((entry, index) => (
                        <React.Fragment key={index}>
                          {index > 0 && " "}
                          {entry}
                        </React.Fragment>
                      ))}
                      )
                    </span>
                  )}
                  &nbsp;&nbsp;
                  <span
                    className="text-end"
                    style={{
                      fontSize: "17px",
                      fontWeight: "500",
                      color: "#566a7f",
                      cursor: "pointer",
                    }}
                    onClick={this.handleAccountDropdownOpen}
                  >
                    <FilterAltIcon
                      style={{
                        fontSize: "28px",
                        color: "rgb(106, 123, 142)",
                      }}
                      aria-controls={
                        this.state.open ? "dropdown-menu" : undefined
                      }
                      aria-haspopup="true"
                      aria-expanded={this.state.open ? "true" : undefined}
                    />
                    Filter
                  </span>
                  {"  "} &nbsp;&nbsp;
                  {this.state.isFirstTimeLoading ? (
                    ""
                  ) : (
                    <span
                      style={{
                        fontSize: "17px",
                        fontWeight: "500",
                        color: "#566a7f",
                        cursor: "pointer",
                      }}
                      onClick={this.resetFilter.bind(this)}
                    >
                      <i class="fa fa-refresh" aria-hidden="true"></i> Reset
                    </span>
                  )}
                </div>
              </div>
              <Menu
                anchorEl={this.state.anchorEl}
                id="dropdown-menu"
                className="filterDropdownMenu"
                open={this.state.open}
                onClose={this.handleAccountDropdownClose}
                // onClick={this.handleAccountDropdownClose}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 20,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <div
                  className="dropdown-item"
                  style={{
                    cursor: "pointer",
                    width: "400px",
                    height: "100%",
                  }}
                >
                  <div className="row">
                    <h5>Filter</h5>
                    <div className="col-md-12 mt-1">
                      <label className="form-label" htmlFor="assetCodeFilter">
                        Asset Code
                      </label>
                      <select
                        id="assetCodeFilter"
                        className="form-select"
                        value={this.state.selectedAssetCodeId}
                        onChange={(event) =>
                          this.setState({ selectedAssetCodeId: event.target.value })
                        }
                      >
                        <option value="">Asset Code</option>
                        {this.state.assetCodeList.map((assetCode) => (
                          <option
                            key={assetCode}
                            value={assetCode}
                          >
                            {assetCode}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-12 mt-1  d-flex justify-content-between">
                      <div className="col-md-6 mt-1">
                        <label
                          className="form-label "
                          htmlFor="collapsible-supplierType"
                        >
                          From Date
                        </label>
                        <br></br>
                        <DatePicker
                          selected={this.state.startDate}
                          onChange={this.handleCycleFromDateChange.bind(this)}
                          dateFormat="d MMM, yyyy"
                          placeholderText="From Date"
                          required
                          className="startDateTimeInput"
                        />
                      </div>
                      &nbsp;
                      <div className="col-md-6 mt-1">
                        <label
                          className="form-label "
                          htmlFor="collapsible-supplierType"
                        >
                          To Date
                        </label>
                        <br></br>
                        <DatePicker
                          selected={this.state.endDate}
                          onChange={this.handleCycleToDateChange.bind(this)}
                          dateFormat="d MMM, yyyy"
                          placeholderText="To Date"
                          required
                          className="endDateTimeInput"
                        />
                      </div>
                    </div>
                    {this.state.error ? (
                      <lable className="danger" style={{ color: "red" }}>
                        To Date should be after From Date
                      </lable>
                    ) : (
                      ""
                    )}
                    <div className="col-md-12 mt-4">
                      <button
                        className="fileterButton"
                        onClick={this.onFilterClick.bind(this)}
                      >
                        <i className="fa-solid fa-filter"></i>
                        &nbsp; Filter
                      </button>
                      &nbsp; &nbsp;
                      <button
                        className="resetButton"
                        onClick={this.resetFilter.bind(this)}
                      >
                        <i className="fa fa-refresh"></i>
                        &nbsp; Reset
                      </button>
                    </div>
                  </div>
                </div>
              </Menu>
              <div className="col md-12 mt-2">
                <div className="card">
                  <div className="row justify-content-between p-2">
                    <div className="d-flex col-12 col-lg-4 col-xl-4">
                      <div className="col-12 text-start totalResults">
                        <span>
                          Total Results: {Utils.formatIndianNumber(this.state.totalRecords)}
                        </span>
                      </div>
                    </div>
                    <div className="d-flex col-12 col-lg-8 col-xl-8">
                      <div className="col-12 text-end">
                        {this.state.totalRecords > 0 && (
                          <Button
                            style={{ marginLeft: "10px" }}
                            variant="contained"
                            size="small"
                            id="excelBtn"
                            startIcon={<i className="fa fa-download"></i>}
                            onClick={this.downloadExcel.bind(this)}
                          >
                            Download Excel
                          </Button>
                        )}
                        <TextField
                          id="standard-search"
                          placeholder="Search"
                          type="search"
                          variant="standard"
                          value={this.state.searchText}
                          onChange={this.onSearchChange.bind(this)}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  onClick={this.getTrakingHistoryList.bind(
                                    this,
                                    0,
                                    this.state.showPerPage,
                                    this.state.searchText
                                  )}
                                >
                                  <SearchIcon />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive paginationTable">
                    <table className="table text-start table-hover">
                      <thead className="paginationTableThead">
                        <tr>
                          <th scope="col fw-bold">#</th>
                          <th scope="col fw-bold">Plan Name</th>
                          <th scope="col fw-bold">Asset Name</th>
                          <th scope="col fw-bold">Asset UID</th>
                          <th scope="col fw-bold">Action</th>
                          <th scope="col fw-bold">First Track</th>
                          <th scope="col fw-bold">Latest Track</th>
                          <th scope="col fw-bold">Creator</th>
                          <th scope="col fw-bold">Location </th>
                          <th scope="col fw-bold">Count</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.trackingHistoryList?.map(
                          (rowData, index) => (
                            <tr
                              key={index}
                              style={{
                                backgroundColor:
                                  rowData.assetid === this.state.assetId
                                    ? "#FEF5E7"
                                    : "#fff",
                              }}
                            >
                              <td>
                                {this.state.pageNo * this.state.showPerPage +
                                  index +
                                  1}
                              </td>
                              <td style={{ width: "260px" }}>
                                {rowData.planName}
                              </td>
                              <td style={{ width: "260px" }}>
                                {rowData.assetname}
                              </td>
                              <td className="assetUID" style={{ width: "170px" }}>
                                <a
                                  // href="#"
                                  onClick={this.toAssetTrakingDetails.bind(
                                    this,
                                    rowData.assetid
                                  )}
                                  style={{ color: "blue", cursor: "pointer" }}
                                >
                                  {rowData.assetuid}
                                </a>
                              </td>
                              <td style={{ width: "30px" }}>
                                {rowData.action}
                              </td>
                              <td style={{ width: "220px" }}>
                                {formatTrackingDateTime(rowData.tdate)}
                              </td>
                              <td style={{ width: "220px" }}>
                                {formatTrackingDateTime(
                                  rowData.tenddate
                                )}
                              </td>
                              <td style={{ width: "140px" }}>
                                <span title={rowData.createdbyName || ""}>
                                  {getUserInitials(rowData.createdbyName)}
                                </span>
                              </td>
                              <td style={{ width: "520px" }}>
                                {rowData.location ? rowData.location : ""}
                              </td>
                              <td style={{ width: "12px" }}>
                                {Utils.formatIndianNumber(rowData.count)}
                              </td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </div>
                  {this.state.totalRecords === 0 && (
                    <div className="row text-center p-2">
                      <h5>
                        {this.state.isFirstTimeLoading
                          ? "Traking history not created yet"
                          : "Data not Available"}
                      </h5>

                    </div>
                  )}
                  {this.state.totalRecords > this.state.pageSize && (
                    <div className="row justify-content-between pagination p-1">
                      <div className="d-flex col-12 col-lg-4 col-xl-4">
                        <div className="pageSize col-12 text-start">
                          Page {this.state.pageNo + 1} of{" "}
                          {this.state.totalPages}
                        </div>
                      </div>
                      <div className="d-flex col-12 col-lg-8 col-xl-8">
                        <div className="col-12 text-end">
                          <Pagination
                            showPerPage={this.state.showPerPage}
                            pageSizeOptions={[20, 50, 100, 500, 2000, 5000]}
                            onPaginationChange={this.onPaginationChange.bind(
                              this
                            )}
                            total={this.state.totalRecords}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      );
    }
  }
}
export default withRouter(AssetTrackingHistoryList);
